export const userTeamSmartImagesEntitiesSelector = state =>
  state.entities.userTeamSmartImages;

export const userTeamSmartImageSelector = ({ state, mediaId }) =>
  state.entities.userTeamSmartImages[mediaId];
